import { BuzerIcon } from "../../../BuzerIcons";
import { Sheet } from "./Sheet";

// Reusable action menu (opened from a ⋯). Common actions on top, destructive
// ones separated below (danger). items: [{ icon, label, desc?, danger?,
// dividerBefore?, onClick }]. Built on the Sheet overlay.
export function ActionMenu({ title = "Akcie", icon = "dots", items = [], onClose }) {
  return (
    <Sheet center title={title} icon={icon} flush onClose={onClose}>
      <div style={{ padding: "8px 8px 6px" }}>
        {items.map((it, i) => (
          <div key={i}>
            {it.dividerBefore && <div style={{ height: 1, background: "var(--neutral-border)", margin: "6px 12px" }} />}
            <button type="button" onClick={() => { onClose && onClose(); it.onClick && it.onClick(); }}
              style={{ width: "100%", display: "flex", alignItems: "center", gap: 13, padding: "11px 12px", border: "none", background: "transparent", borderRadius: "var(--radius-sm)", cursor: "pointer", textAlign: "left", fontFamily: "var(--ff-ui)", WebkitTextFillColor: "currentColor" }}>
              <span style={{ width: 34, height: 34, flexShrink: 0, borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", background: it.danger ? "var(--destructive-surface)" : "var(--neutral-surface-3)", color: it.danger ? "var(--destructive)" : "var(--neutral-text-muted)" }}>
                <BuzerIcon name={it.icon} size={17} color="currentColor" />
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: "block", fontSize: 14.5, fontWeight: it.danger ? 700 : 600, color: it.danger ? "var(--destructive)" : "var(--neutral-text-main)" }}>{it.label}</span>
                {it.desc && <span style={{ display: "block", fontSize: 12, color: "var(--neutral-text-muted)", marginTop: 1 }}>{it.desc}</span>}
              </span>
            </button>
          </div>
        ))}
      </div>
    </Sheet>
  );
}
